(function () {
	function unwrapSlideWrappers(root = document) {
		const containers = root.querySelectorAll('.component-swiper-container__wrapper > .acf-innerblocks-container');
		if (!containers.length) return; // No wrappers found, exit early

		containers.forEach(container => {
			const parent = container.parentElement;

			// Move children out of the inner wrapper
			while (container.firstChild) {
				parent.insertBefore(container.firstChild, container);
			}

			// Remove the now-empty wrapper
			container.remove();
		});
	}

	// Run on initial DOM load (frontend)
	document.addEventListener('DOMContentLoaded', () => {
		unwrapSlideWrappers();
	});
})();
